module.exports = __webpack_public_path__ + "img/app04.2131362e.png";